__turbopack_context__.v({
  "backdrop": "Modal-module-scss-module__mnQuTW__backdrop",
  "backdropFade": "Modal-module-scss-module__mnQuTW__backdropFade",
  "backdropIn": "Modal-module-scss-module__mnQuTW__backdropIn",
  "bottomSheetModal": "Modal-module-scss-module__mnQuTW__bottomSheetModal",
  "bottomSheetSlideInDown": "Modal-module-scss-module__mnQuTW__bottomSheetSlideInDown",
  "cardScaleOut": "Modal-module-scss-module__mnQuTW__cardScaleOut",
  "fadeColor": "Modal-module-scss-module__mnQuTW__fadeColor",
  "fullScreenFadeOut": "Modal-module-scss-module__mnQuTW__fullScreenFadeOut",
  "modal": "Modal-module-scss-module__mnQuTW__modal",
  "modalFadeOut": "Modal-module-scss-module__mnQuTW__modalFadeOut",
  "modalOpen": "Modal-module-scss-module__mnQuTW__modalOpen",
  "modalPinned": "Modal-module-scss-module__mnQuTW__modalPinned",
});
